import App from "./App.vue";
import router from "./router";
import { setupStore } from "@/store";
import ElementPlus from "element-plus";
import { getServerConfig } from "./config";
import { createApp, Directive } from "vue";
import { MotionPlugin } from "@vueuse/motion";
import { injectResponsiveStorage } from "@/utils/responsive";
import { loadEnv } from "@build/index";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import "animate.css";
// 引入重置样式
import "./style/reset.scss";
// 导入公共样式
import "./style/index.scss";
import "element-plus/dist/index.css";
import "@pureadmin/components/dist/index.css";
import "@pureadmin/components/dist/theme.css";
import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/iconfont.css";
const { VITE_NODE_ENV } = loadEnv();

const app = createApp(App);

// 自定义指令
import * as directives from "@/directives";
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string]: Directive })[key]);
});

// 全局注册`@iconify/vue`图标库
import {
  IconifyIconOffline,
  IconifyIconOnline,
  FontIcon
} from "./components/ReIcon";
app.component("IconifyIconOffline", IconifyIconOffline);
app.component("IconifyIconOnline", IconifyIconOnline);
app.component("FontIcon", FontIcon);

// 全局注册按钮级别权限组件
import { Auth } from "@/components/ReAuth";
app.component("Auth", Auth);

// 全局注册app main内title组件
import OTitle from "@/components/base/o_title.vue";
app.component("OTitle", OTitle);
// 全局注册头、底部组件
import vheader from "@/components/base/vheader.vue";
app.component("vheader", vheader);
import vfooter from "@/components/base/vfooter.vue";
app.component("vfooter", vfooter);

// 监控相关
const tracingOrigins =
  VITE_NODE_ENV === "test"
    ? ["shengpay.com/globalpay"]
    : ["shengpayglobal.com/globalpay/"];
const sentryDsn =
  VITE_NODE_ENV === "test"
    ? "http://222ab189db234306881f683e6df6e71d@10.132.99.116:9000/15"
    : "https://222ab189db234306881f683e6df6e71d@sentrytest.shengpay.com/15";
if (VITE_NODE_ENV !== "dev") {
  // Sentry.init({
  //   app,
  //   dsn: sentryDsn,
  //   integrations: [
  //     new Integrations.BrowserTracing({
  //       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //       tracingOrigins: tracingOrigins
  //     })
  //   ],
  //   tracesSampleRate: 1.0,
  //   hooks: ["create", "mount"],
  //   logErrors: true,
  //   environment: VITE_NODE_ENV
  // });
}

getServerConfig(app).then(async config => {
  app.use(router);
  await router.isReady();
  injectResponsiveStorage(app, config!);
  setupStore(app);
  app.use(MotionPlugin).use(ElementPlus);
  app.mount("#app");
});
